const SEASON_TYPE_DROP_DOWN_OPTIONS = [
  {
    label: "Busy",
    value: "Busy",
  },
  {
    label: "Lean",
    value: "Lean",
  },
  {
    label: "Busy waived as Lean",
    value: "Busy waived as Lean",
  },
];
const RAKE_TYPE_DROP_DOWN_OPTIONS = [
  {
    label: "BFNS",
    value: "BFNS",
  },
  {
    label: "BFNSM",
    value: "BFNSM",
  },
];
const RAKE_TYPE_OPTIONS = [
  {
    label: "BFNS",
    value: "BFNS",
  },
  {
    label: "BFNSM",
    value: "BFNSM",
  },
  {
    label: "BFNV",
    value: "BFNV",
  },
  {
    label: "BOXNHL",
    value: "BOXNHL",
  },
  {
    label: "BOXNHL 22.9T",
    value: "BOXNHL 22.9T",
  },
  {
    label: "BOXNHL 25T",
    value: "BOXNHL 25T",
  },
];
const DAMAGE_WAGON_DROP_DOWN_OPTIONS = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
const NEW_CYCLE_CREATE_OPTIONS = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
const QUOTATION_APPROVAL_STATUS = [
  {
    label: "Approved",
    value: "Approved",
  },
  {
    label: "Rejected",
    value: "Rejected",
  },
];
const FREIGHT_PAID_BY_OPTIONS = [
  {
    label: "TMILL",
    value: "TMILL",
  },
  {
    label: "Customer",
    value: "Customer",
  },
];
const RAKE_FULL_LOAD_OPTIONS = [
  {
    label: "Full Load",
    value: "Full Load",
  },
  {
    label: "Part Load",
    value: "Part Load",
  },
  {
    label: "Extra Load",
    value: "Extra Load",
  },
];
const RECORD_STATUS = {
  SAVE_AS_DRAFT: "D",
  ACTIVE: "A",
  SUBMITTED: "S",
  INACTIVE: "IA",
};
const RAKE_STATUS = [
  { label: "Empty", value: "Empty" },
  { label: "Loaded", value: "Loaded" },
];
const DESTINATION_TYPE_LIST = [
  {
    label: "Public Terminal",
    value: "Public Terminal",
  },
  {
    label: "Private Terminal",
    value: "Private Terminal",
  },
  {
    label: "Railways Good Shed",
    value: "Railways Good Shed",
  },
];
const ENROUTE_WAGON_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
const CARGO_PACKING_LIST = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
const DAMAGE_WAGON_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
const CUSTOMER_WORK_ORDER_RECIVED_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
const ROUTE_LIST = [
  {
    HYDERABAD: "Hyderabad",
    WARANGAL: "Warangal",
    KHAMMAM: "Khammam",
  },
];
const RAILWAY_DIVISION_LIST = [
  {
    label: "BB",
    value: "BB",
  },
  {
    label: "PA",
    value: "PA",
  },
  {
    label: "SUR",
    value: "SUR",
  },
  {
    label: "KUR",
    value: "KUR",
  },
  {
    label: "DHN",
    value: "DHN",
  },
  {
    label: "MGS",
    value: "MGS",
  },
];
const SEVERITY_OF_DAMAGE_OPTIONS = [
  {
    label: "High",
    value: "High",
  },
  {
    label: "Medium",
    value: "Medium",
  },
  {
    label: "Low",
    value: "Low",
  },
];
const SCHEME_TYPE_OPTIONS = [
  {
    label: "SFTO",
    value: "SFTO",
  },
  {
    label: "GPWIS",
    value: "GPWIS",
  },
];
const JOB_AT_DESTINATION_OPTIONS = [
  {
    label: "Loading",
    value: "Loading",
  },
  {
    label: "Unloading",
    value: "Unloading",
  },
];
const ALLOWED_EXTENSIONS = ["csv", "pdf", "xls", "xlsx", "doc", "docx"];
const MAX_UPLOAD_SIZE = 50000;
const JOB_APPROVAL_PICKLIST_OPTIONS = [
  {
    label: "Approve",
    value: "Approve",
  },
  {
    label: "Pending For Approval",
    value: "Pending For Approval",
  },
  {
    label: "Reject",
    value: "Reject",
  },
];
const JOB_TYPE_OPTIONS = [
  {
    label: "Full",
    value: "Full",
  },
  {
    label: "Part",
    value: "Part",
  },
  // {
  //   label: "Multiple RR",
  //   value: "Multiple RR",
  // },
  {
    label: "Two Point Loading",
    value: "Two Point Loading",
  },
];
const ROUTE_TYPE_OPTIONS = [
  // {
  //   label: "Shortest Route",
  //   value: "Shortest Route",
  // },
  {
    label: "Rationalized Route",
    value: "Rationalized Route",
  },
  {
    label: "Other Route",
    value: "Other Route",
  },
];
const GPWIS_JOB_COMPLETE_OPTIONS = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
const CARGO_OWNER_OPTIONS = [
  {
    label: "Owner 1",
    value: "Owner 1",
  },
  {
    label: "Owner 2",
    value: "Owner 2",
  },
  {
    label: "Owner 3",
    value: "Owner 3",
  },
];
const INSPECTION_PO_TO_BE_RENEWED_OPTIONS = [
  {
    label: "Appoint New Agency",
    value: "Appoint New Agency",
  },
  {
    label: "Renew Existing PO",
    value: "Renew Existing PO",
  },
  {
    label: "Use Existing PO",
    value: "Use Existing PO",
  },
];
const MANUFACTURING_SURVEY_TERMS_OPTIONS = [
  {
    label: "Stage-wise",
    value: "Stage-wise",
  },
  {
    label: "Pre-delivery",
    value: "Pre-delivery",
  },
];
const DUMMY_OPTIONS = [
  {
    label: "NO Options",
    value: "No Options",
  },
];
const TYPE_OF_MAINTENANCE_OPTIONS = [
  {
    label: "ROH",
    value: "ROH",
  },
  {
    label: "POH",
    value: "POH",
  },
];
const BASE_DEPOT_OPTIONS = [
  {
    label: "Depot-1",
    value: "Depot-1",
  },
  {
    label: "Depot-2",
    value: "Depot-2",
  },
];
const COMPLETED_AS_PER_SPEC_OPTIONS = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
const FREIGHT_AND_INSURANCE_TO_BE_PAID_OPTIONS = [
  {
    label: "TMILL",
    value: "TMILL",
  },
  {
    label: "Leaser",
    value: "Leaser",
  },
  {
    label: "Manufacturer",
    value: "Manufacturer",
  },
  {
    label: "Customer",
    value: "Customer",
  },
];
const MANUFACTURING_COMPLETED_OPTIONS = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
const RAKE_IS_FIT_TO_RUN_OPTIONS = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
const MODE_OF_TRANSPORT_OPTIONS = [
  {
    label: "Rail",
    value: "Rail",
  },
  {
    label: "Road",
    value: "Road",
  },
];
const FREIGHT_TO_BE_PAID_BY_OPTIONS = [
  {
    label: "TMILL",
    value: "TMILL",
  },
  {
    label: "Leaser",
    value: "Leaser",
  },
  {
    label: "Manufacturer",
    value: "Manufacturer",
  },
  {
    label: "Customer",
    value: "Customer",
  },
];
const TYPE_OF_DAMAGE_OPTIONS = [
  {
    label: "Replace With Spare Wagon",
    value: "Replace With Spare Wagon",
  },
  {
    label: "Repaired",
    value: "Repaired",
  },
];
const POLICY_TYPE_OPTIONS = [
  {
    label: "GPWIS",
    value: "GPWIS",
  },
  {
    label: "SFTO",
    value: "SFTO",
  },
];
const MANUFACTURER_NAME_OPTIONS = [
  {
    label: "Titagarh Wagons Ltd",
    value: "Titagarh Wagons Ltd",
  },
  {
    label: "Texmaco Rail & Engineering Ltd",
    value: "Texmaco Rail & Engineering Ltd",
  },
  {
    label: "Braithwaite & Co Ltd",
    value: "Braithwaite & Co Ltd",
  },
  {
    label: "Jupiter Wagons Ltd",
    value: "Jupiter Wagons Ltd",
  },
  {
    label: "Jindal Rail Infrastructure Ltd (JRIL)",
    value: "Jindal Rail Infrastructure Ltd (JRIL)",
  },
  {
    label: "Hindusthan Engineering And Industries Ltd (HEIL)",
    value: "Hindusthan Engineering And Industries Ltd (HEIL) ",
  },
];
const DESTINATION_TYPES_OPTIONS = [
  {
    label: "Private Terminal",
    value: "Private Terminal",
  },
  {
    label: "Private Freight Terminal",
    value: "Private Freight Terminal",
  },
  {
    label: "Public Terminal",
    value: "Public Terminal",
  },
];
const DIVISION_NAME_OPTIONS = [
  {
    label: "Division1",
    value: "Division1",
  },
  {
    label: "Division2",
    value: "Division2",
  },
  {
    label: "Division3",
    value: "Division3",
  },
  {
    label: "Division4",
    value: "Division4",
  },
];
const STATION_TYPE_OPTIONS = [
  {
    label: "Passing Station",
    value: "Passing Station",
  },
  {
    label: "Division Interchange Point",
    value: "Division Interchange Point",
  },
  {
    label: "Crew Change Point",
    value: "Crew Change Point",
  },
];
const CUSTOMER_GROUP_5_OPTIONS = [
  {
    label: "B2B",
    value: "B2B",
  },
];
const VENDOR_CODE_PICKLIST_OPTIONS = [
  {
    label: "0000400031",
    value: "0000400031",
  },
  {
    label: "0000400032",
    value: "0000400032",
  },
  {
    label: "0000400033",
    value: "0000400033",
  },
  {
    label: "0000400034",
    value: "0000400034",
  },
];
const JOB_STATUS_PICKLIST_OPTIONS = [
  {
    label: "New Job Created",
    value: "New Job Created",
  },
  {
    label: "Proforma Invoice Sent to Customer",
    value: "Proforma Invoice Sent to Customer",
  },
  {
    label: "Rake arrived at Yard",
    value: "Rake arrived at Yard",
  },
  // {
  //   label: "Rake under examination",
  //   value: "Rake under examination",
  // },
  {
    label: "Rake arrived at plant",
    value: "Rake arrived at plant",
  },
  {
    label: "Loading ongoing",
    value: "Loading ongoing",
  },
  {
    label: "Loading completed",
    value: "Loading completed",
  },
  // {
  //   label: "RR Generated",
  //   value: "RR Generated",
  // },
  {
    label: "Rake Departed from Origin",
    value: "Rake Departed from Origin",
  },
  {
    label: "Rake in Transit",
    value: "Rake in Transit",
  },

  {
    label: "Rake placed at destination",
    value: "Rake placed at destination",
  },
  {
    label: "unloading ongoing",
    value: "unloading ongoing",
  },
  {
    label: "Unloading Completed",
    value: "Unloading Completed",
  },
  {
    label: "Partially Invoiced",
    values: "Partially Invoiced",
  },
  {
    label: "Invoice Generated",
    value: "Invoice Generated",
  },
  {
    label: "Rake on return transit",
    value: "Rake on return transit",
  },
  {
    label: "Rake arrived at return station",
    value: "Rake arrived at return station",
  },
  {
    label: "Approved",
    value: "Approved",
  },
  {
    label: "Rejected",
    value: "Rejected",
  },
];
const THRESHOLD_TYPE_PICKLIST_OPTIONS = [
  {
    label: "Pre Threshold",
    value: "Pre Threshold",
  },
  {
    label: "Post Threshold",
    value: "Post Threshold",
  },
];
const THRESHOLD_LOGIC_TYPE_PICKLIST_OPTIONS = [
  {
    label: "Date",
    value: "Date",
  },
  {
    label: "Quantity",
    value: "Quantity",
  },
  {
    label: "Value",
    value: "Value",
  },
];
const ADVANCE_TERMS_PICKLIST_OPTIONS = [
  {
    label: "F",
    value: "F",
  },
  {
    label: "FF",
    value: "FF",
  },
];
const SERVICE_TYPE_OPTIONS = [
  {
    label: "Freight",
    value: "Freight",
  },
  {
    label: "Fees",
    value: "Fees",
  },
  {
    label: "Rebate",
    value: "Rebate",
  },
];

const SERVICE_TYPE_GPWIS_OPTIONS = [
  {
    label: "Fees",
    value: "Fees",
  },
  {
    label: "Freight/Rebate",
    value: "Freight/Rebate",
  },
];

const CARGO_STATUS_OPTIONS = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Inactive",
    value: "Inactive",
  },
];

const EXAMINATION_TYPE_OPTIONS = [
  {
    label: "EToE",
    value: "EToE",
  },
  {
    label: "PME",
    value: "PME",
  },
  {
    label: "Premium",
    value: "Premium",
  },
];
const WAGON_TYPE_OPTIONS = [
  {
    label: "BOXNHL",
    value: "BOXNHL",
  },
  {
    label: "BFNS",
    value: "BFNS",
  },
  {
    label: "BFNSM",
    value: "BFNSM",
  },
];
const MANUFACTURER_NAME = [
  {
    label: "Braithwaite & Co Ltd",
    value: "Braithwaite & Co Ltd",
  },
  {
    label: "Titagarh",
    value: "Titagarh",
  },
];

const FINANCIAL_YEARS_DROPDOWN = [
  { label: "2023-2024", value: "2023-2024" },
  { label: "2022-2023", value: "2022-2023" },
  { label: "2021-2022", value: "2021-2022" },
];

const FINANCIAL_MONTH_DROPDOWN = [
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" },
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" },
  // { label: "2023-2024", value: "2023-2024" },
];
const REBATE_OPTION = [
  { label: "Yearly Cap", value: "Yearly Cap" },
  { label: "No Cap", value: "No Cap" },
];

const INVOICE_MONTH_DROPDOWN = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const INVOICE_REPORT_QUARTER_DROPDOWN = [
  {
    label: "Q1",
    value: "Q1",
    months: [
      { label: "April", value: "04" },
      { label: "May", value: "05" },
      { label: "June", value: "06" },
    ],
  },
  {
    label: "Q2",
    value: "Q2",
    months: [
      { label: "July", value: "07" },
      { label: "August", value: "08" },
      { label: "September", value: "09" },
    ],
  },
  {
    label: "Q3",
    value: "Q3",
    months: [
      { label: "October", value: "10" },
      { label: "November", value: "11" },
      { label: "December", value: "12" },
    ],
  },
  {
    label: "Q4",
    value: "Q4",
    months: [
      { label: "January", value: "01" },
      { label: "February", value: "02" },
      { label: "March", value: "03" },
    ],
  },
];

const SFTO_JOB_MOVEMENT_TYPE = [
  {
    label: "Loaded Movement(L)",
    value: "L",
  },
  {
    label: "Empty Movement(E)",
    value: "E",
  },
  {
    label: "Maintenance Trip(M)",
    value: "M",
  },
  {
    label: "IR Movement(IR)",
    value: "IR",
  },
];

const GPWIS_JOB_MOVEMENT_TYPE = [
  {
    label: "Loaded Movement(L)",
    value: "L",
  },
  {
    label: "Empty Movement(E)",
    value: "E",
  },
  {
    label: "Maintenance Trip(M)",
    value: "M",
  },
  {
    label: "IR Movement(IR)",
    value: "IR",
  },
];

const INVOICE_MODE_OPTIONS = [
  {
    label: "E-Mail",
    value: "E-Mail",
  },
  {
    label: "E-Proc",
    value: "E-Proc",
  },
  {
    label: "Physical",
    value: "Physical",
  },
];

const CONCERNS_OPTIONS = [
  {
    label: "Clear Outstanding",
    value: "Clear Outstanding",
  },
  {
    label: "WO Issues",
    value: "WO Issues",
  },
  {
    label: "Deduction",
    value: "Deduction",
  },
  {
    label: "Credit Note Issue",
    value: "Credit Note Issue",
  },
  {
    label: "Under Ebilling",
    value: "Under Ebilling",
  },
  {
    label: "Eproc Issue",
    value: "Eproc Issue",
  },
  {
    label: "Reversal",
    value: "Reversal",
  },
];

const STAION_MASTER_ZONE_OPTIONS = [
  {
    label: "CR",
    value: "CR",
  },
  {
    label: "ER",
    value: "ER",
  },
  {
    label: "ECR",
    value: "ECR",
  },
  {
    label: "ECOR",
    value: "ECOR",
  },
  {
    label: "NR",
    value: "NR",
  },
  {
    label: "NCR",
    value: "NCR",
  },
  {
    label: "NER",
    value: "NER",
  },
  {
    label: "NFR",
    value: "NFR",
  },
  {
    label: "NWR",
    value: "NWR",
  },
  {
    label: "SR",
    value: "SR",
  },
  {
    label: "SCR",
    value: "SCR",
  },
  {
    label: "SER",
    value: "SER",
  },
  {
    label: "SECR",
    value: "SECR",
  },
  {
    label: "SWR",
    value: "SWR",
  },
  {
    label: "WR",
    value: "WR",
  },
  {
    label: "WCR",
    value: "WCR",
  },
];

const RAKE_STATUS_OPTIONS = [
  {
    label: "Fit",
    value: "Fit",
  },
  {
    label: "Sick",
    value: "Sick",
  },
  {
    label: "ROH",
    value: "ROH",
  },
  {
    label: "POH",
    value: "POH",
  },
];

const RR_WEIGHT_OPTIONS = [
  {
    label: "Actual Weight",
    value: "Actual Weight",
  },
  {
    label: "Chargeable Weight",
    value: "Chargeable Weight",
  },
];

const RAKE_COMPOSITION_OPTIONS = [
  {
    label: "Original",
    value: "Original",
  },
  {
    label: "Running",
    value: "Running",
  },
];

const MOVED_WITH_SCHEDULE_OPTIONS = [
  {
    label: "Rake",
    value: "Rake",
  },
  {
    label: "Spare",
    value: "Spare",
  },
];

const SCHEDULE_STATUS_OPTIONS = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Completed",
    value: "Completed",
  },
];

const SPARE_SCHEDULE_STATUS_OPTIONS = [
  {
    label: "Done",
    value: "Done",
  },
  {
    label: "Due",
    value: "Due",
  },
];

const ACCOUNT_TO = [
  {
    label: "TMILL",
    value: "TMILL",
  },
  {
    label: "Customer",
    value: "Customer",
  },
  {
    label: "Railways",
    value: "Railways",
  },
  {
    label: "Insurance",
    value: "Insurance",
  },
];

const Reconciliation_REASON = [
  {
    label: "Rebate variation",
    value: "Rebate variation",
  },
  {
    label: "Longer route freight",
    value: "Longer route freight",
  },
  {
    label: "TLC",
    value: "TLC",
  },
  {
    label: "WO Rate Variation",
    value: "WO Rate Variation",
  },
  {
    label: "Wrong collection by IR",
    value: "Wrong collection by IR",
  },
  {
    label: "Others",
    value: "Others",
  },
];

const StatusClaimOptions = [
  {
    label: "Claim Submitted",
    value: "Claim Submitted",
  },
  {
    label: "Processed",
    value: "Processed",
  },
  {
    label: "Partial Receipt",
    value: "Partial Receipt",
  },
  {
    label: "Full Receipt",
    value: "Full Receipt",
  },
  {
    label: "Rejected",
    value: "Rejected",
  },
];

const EprocSchemeType = [
  {
    label: "GPWIS",
    value: "GPWIS",
  },
  {
    label: "SFTO",
    value: "SFTO",
  },
  {
    label: "N/A",
    value: "N/A",
  },
];

const exportObj = {
  FINANCIAL_MONTH_DROPDOWN,
  SEASON_TYPE_DROP_DOWN_OPTIONS,
  DAMAGE_WAGON_DROP_DOWN_OPTIONS,
  FREIGHT_PAID_BY_OPTIONS,
  RAKE_FULL_LOAD_OPTIONS,
  RECORD_STATUS,
  RAKE_STATUS,
  ROUTE_LIST,
  DESTINATION_TYPE_LIST,
  ENROUTE_WAGON_OPTIONS,
  FINANCIAL_YEARS_DROPDOWN,
  CARGO_PACKING_LIST,
  DAMAGE_WAGON_OPTIONS,
  EXAMINATION_TYPE_OPTIONS,
  RAILWAY_DIVISION_LIST,
  SEVERITY_OF_DAMAGE_OPTIONS,
  ALLOWED_EXTENSIONS,
  MAX_UPLOAD_SIZE,
  SCHEME_TYPE_OPTIONS,
  NEW_CYCLE_CREATE_OPTIONS,
  RAKE_TYPE_DROP_DOWN_OPTIONS,
  ROUTE_TYPE_OPTIONS,
  JOB_AT_DESTINATION_OPTIONS,
  JOB_APPROVAL_PICKLIST_OPTIONS,
  GPWIS_JOB_COMPLETE_OPTIONS,
  CARGO_OWNER_OPTIONS,
  RAKE_TYPE_OPTIONS,
  CUSTOMER_WORK_ORDER_RECIVED_OPTIONS,
  DUMMY_OPTIONS,
  QUOTATION_APPROVAL_STATUS,
  INSPECTION_PO_TO_BE_RENEWED_OPTIONS,
  MANUFACTURING_SURVEY_TERMS_OPTIONS,
  TYPE_OF_MAINTENANCE_OPTIONS,
  BASE_DEPOT_OPTIONS,
  COMPLETED_AS_PER_SPEC_OPTIONS,
  MANUFACTURING_COMPLETED_OPTIONS,
  RAKE_IS_FIT_TO_RUN_OPTIONS,
  FREIGHT_AND_INSURANCE_TO_BE_PAID_OPTIONS,
  MODE_OF_TRANSPORT_OPTIONS,
  FREIGHT_TO_BE_PAID_BY_OPTIONS,
  TYPE_OF_DAMAGE_OPTIONS,
  POLICY_TYPE_OPTIONS,
  MANUFACTURER_NAME_OPTIONS,
  DESTINATION_TYPES_OPTIONS,
  DIVISION_NAME_OPTIONS,
  STATION_TYPE_OPTIONS,
  CUSTOMER_GROUP_5_OPTIONS,
  VENDOR_CODE_PICKLIST_OPTIONS,
  JOB_STATUS_PICKLIST_OPTIONS,
  THRESHOLD_TYPE_PICKLIST_OPTIONS,
  THRESHOLD_LOGIC_TYPE_PICKLIST_OPTIONS,
  ADVANCE_TERMS_PICKLIST_OPTIONS,
  SERVICE_TYPE_OPTIONS,
  SERVICE_TYPE_GPWIS_OPTIONS,
  CARGO_STATUS_OPTIONS,
  WAGON_TYPE_OPTIONS,
  MANUFACTURER_NAME,
  INVOICE_MONTH_DROPDOWN,
  INVOICE_REPORT_QUARTER_DROPDOWN,
  REBATE_OPTION,
  SFTO_JOB_MOVEMENT_TYPE,
  GPWIS_JOB_MOVEMENT_TYPE,
  INVOICE_MODE_OPTIONS,
  CONCERNS_OPTIONS,
  JOB_TYPE_OPTIONS,
  STAION_MASTER_ZONE_OPTIONS,
  RAKE_STATUS_OPTIONS,
  RR_WEIGHT_OPTIONS,
  RAKE_COMPOSITION_OPTIONS,
  MOVED_WITH_SCHEDULE_OPTIONS,
  SCHEDULE_STATUS_OPTIONS,
  SPARE_SCHEDULE_STATUS_OPTIONS,
  ACCOUNT_TO,
  Reconciliation_REASON,
  StatusClaimOptions,
  EprocSchemeType,
};

export default exportObj;
